import './App.css';
import React, { Suspense } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route }from 'react-router-dom';
import Home from './pages';
import Console from './pages/console';
import Faq from './pages/faq';
import './i18n'
import Notice from './pages/notice';
import Text from './components/textPage';
import Text1 from './components/textPage1';
import ConsoleFaq from './pages/consoleFaq';

function App() {
  return (
    <Suspense fallback="loading">
      <Router>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/console' element={<Console/>}  />
          <Route path='/user/faq' element={<Faq/>} />
          <Route path='/console/faq' element={<ConsoleFaq/>} />
          <Route path='/notice' element={<Notice/>}/>
          <Route path="/notice/1" element={<Text />}/>
          <Route path="/notice/2" element={<Text1 />}/>
        </Routes>
      </Router>
    </Suspense>
    
  );
}

export default App;
